export default __webpack_public_path__ + "static/media/logo.37c5b00c.png";